import angular from "angular";

export default myApp =>
  myApp
    .config(function(FacebookProvider, cfpLoadingBarProvider) {
      FacebookProvider.init("714232412072049");
      cfpLoadingBarProvider.includeSpinner = true;
    })
    .config([
      "$controllerProvider",
      function($controllerProvider) {
        myApp.registerController = $controllerProvider.register;
      }
    ])
    .config([
      "$stateProvider",
      "$urlRouterProvider",
      "$locationProvider",
      function($stateProvider, $urlRouterProvider, $locationProvider) {
        $stateProvider
          .state("home", {
            url: "/",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./home/home.html"], function() {
                  let template = require("./home/home.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              home: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./home").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "HomeController"
          })
          .state("jio", {
            url: "/jio",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./jio/jio.html"], function() {
                  let template = require("./jio/jio.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              jio: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./jio").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "JioController"
          })
          .state("searchHours", {
            url:
              "/searchHours/:bookingType/:hotelNAme/:lat/:lng/:checkInDate/:checkInTime/:checkInDisplayTime/:noOfHours/:country/:city/:numberOfRooms/:numberOfAdults/:numberOfChildren",
            controller: "SearchController",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                
                require.ensure(["./search/search.html"], function() {
                  let template = require("./search/search.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              search: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./search").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });
                  
                  return deferred.promise;
                }
              ]
            }
          })
          .state("searchNights", {
            url:
              "/searchNights/:bookingType/:hotelNAme/:lat/:lng/:checkInDate/:checkOutDate/:country/:city/:numberOfRooms/:numberOfAdults/:numberOfChildren",
            controller: "SearchController",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./search/search.html"], function() {
                  let template = require("./search/search.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              search: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./search").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            }
          })

          .state("hotelInfoSlots", {
            url:
              "/hotelInfoSlots/:bookingType/:hotelId/:sourcedFrom/:currencyCode/:hotelName/:checkInDate/:hotelSlotCheckInTime/:checkInDisplayTime/:slotHours/:lat/:lng/:country/:city/:numberOfRooms/:numberOfAdults/:numberOfChildren/:workFromHotel",
            controller: "HotelInfoController",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./hotelInfo/hotelInfo.html"], function() {
                  let template = require("./hotelInfo/hotelInfo.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              hotelInfo: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./hotelInfo").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            }
          })
          .state("hotelInfoNights", {
            url:
              "/hotelInfoNights/:bookingType/:hotelId/:sourcedFrom/:currencyCode/:hotelName/:checkInDate/:checkOutDate/:lat/:lng/:country/:city/:numberOfRooms/:numberOfAdults/:numberOfChildren",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./hotelInfo/hotelInfo.html"], function() {
                  let template = require("./hotelInfo/hotelInfo.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              home: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./hotelInfo").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "HotelInfoController"
          })

          .state("checkoutSlots", {
            url:
              "/checkoutSlots/:bookingType/:hotelId/:roomId/:sourcedFrom/:currencyCode/:checkInDate/:checkInTime/:noOfHours/:slotName/:lat/:lng/:numberOfRooms/:numberOfAdults/:numberOfChildren",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./checkout/checkout.html"], function() {
                  let template = require("./checkout/checkout.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              checkout: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./checkout").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "CheckoutController"
          })

          .state("checkoutNights", {
            url:
              "/checkoutNights/:bookingType/:hotelId/:roomId/:sourcedFrom/:currencyCode/:checkInDate/:checkOutDate/:lat/:lng/:numberOfRooms/:numberOfAdults/:numberOfChildren/:RatePlanId",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./checkout/checkout.html"], function() {
                  let template = require("./checkout/checkout.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              checkout: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./checkout").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "CheckoutController"
          })

          .state("paymentHourly", {
            url:
              "/paymentHourly/:bookingType/:hotelId/:roomId/:sourcedFrom/:currencyCode/:checkInDate/:checkInTime/:noOfHours/:slotName/:lat/:lng/:numberOfRooms/:numberOfAdults/:numberOfChildren/:userName/:userEmail/:userMobile",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./payment/payment.html"], function() {
                  let template = require("./payment/payment.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              payment: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./payment").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "PaymentController"
          })

          .state("paymentNights", {
            url:
              "/paymentNights/:bookingType/:hotelId/:roomId/:sourcedFrom/:currencyCode/:checkInDate/:checkOutDate/:lat/:lng/:numberOfRooms/:numberOfAdults/:numberOfChildren/:userName/:userEmail/:userMobile",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./payment/payment.html"], function() {
                  let template = require("./payment/payment.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              payment: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./payment").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "PaymentController"
          })

          .state("paymentHourlyGuest", {
            url:
              "/paymentHourlyGuest/:bookingType/:hotelId/:roomId/:sourcedFrom/:currencyCode/:checkInDate/:checkInTime/:noOfHours/:slotName/:lat/:lng" +
              "/:numberOfRooms/:numberOfAdults/:numberOfChildren/:userName/:userEmail/:userMobile",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./payment/payment.html"], function() {
                  let template = require("./payment/payment.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              payment: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./payment").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "PaymentController"
          })

          .state("paymentNightsGuest", {
            url:
              "/paymentNightsGuest/:bookingType/:hotelId/:roomId/:sourcedFrom/:currencyCode/:checkInDate/:checkOutDate/:lat/:lng/:numberOfRooms" +
              "/:numberOfAdults/:numberOfChildren/:userName/:userEmail/:userMobile",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./payment/payment.html"], function() {
                  let template = require("./payment/payment.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              payment: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./payment").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "PaymentController"
          })
          .state("orderSuccess", {
            url: "/orderSuccess/:bookingId",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./orderSuccess/orderSuccess.html"],
                  function() {
                    let template = require("./orderSuccess/orderSuccess.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ],
            resolve: {
              orderSuccess: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./orderSuccess").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "OrderSuccessController"
          })
          .state("orderSuccessAtHotel", {
            url: "/orderSuccessAtHotel/:bookingId",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./orderSuccess/orderSuccess.html"],
                  function() {
                    let template = require("./orderSuccess/orderSuccess.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ],
            resolve: {
              orderSuccess: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./orderSuccess").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "OrderSuccessController"
          })
          .state("orderFailure", {
            url: "/orderFailure/:failureMessage",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./orderFailure/orderFailure.html"],
                  function() {
                    let template = require("./orderFailure/orderFailure.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ],
            resolve: {
              orderFailure: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./orderFailure").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "OrderFailureController"
          })
          .state("profile", {
            url: "/profile",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./profile/profile.html"], function() {
                  let template = require("./profile/profile.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              orderSuccess: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./profile").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "ProfileController"
          })
          .state("status", {
            url: "/status/:bookingId",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./status/status.html"], function() {
                  let template = require("./status/status.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              orderSuccess: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./status").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "StatusController"
          })
          .state("termsAndConditions", {
            url: "/termsAndConditions",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./termsAndConditions/termsAndConditions.html"],
                  function() {
                    let template = require("./termsAndConditions/termsAndConditions.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ]
          })
          .state("privacyPolicy", {
            url: "/privacyPolicy",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./privacyPolicy/privacyPolicy.html"],
                  function() {
                    let template = require("./privacyPolicy/privacyPolicy.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ]
          })
          .state("refundPolicy", {
            url: "/refundPolicy",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./refundPolicy/refundPolicy.html"],
                  function() {
                    let template = require("./refundPolicy/refundPolicy.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ]
          })
          .state("cookiePolicy", {
            url: "/cookiePolicy",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./cookiePolicy/cookiePolicy.html"],
                  function() {
                    let template = require("./cookiePolicy/cookiePolicy.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ]
          })
          .state("faq", {
            url: "/faq",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./faq/faq.html"], function() {
                  let template = require("./faq/faq.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ]
          })
          .state("blog", {
            url: "/blog",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./blog/blog.html"], function() {
                  let template = require("./blog/blog.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ]
          })
          .state("coreTeam", {
            url: "/coreTeam",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./coreTeam/coreTeam.html"], function() {
                  let template = require("./coreTeam/coreTeam.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ]
          })
          .state("contactUs", {
            url: "/contactUs",
            controller: "ContactUsController",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./contactUs/contactUs.html"], function() {
                  let template = require("./contactUs/contactUs.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              contactUs: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./contactUs").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            }
          })
          .state("aboutUs", {
            url: "/aboutUs",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./aboutUs/aboutUs.html"], function() {
                  let template = require("./aboutUs/aboutUs.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ]
          })
          .state("whatsNew", {
            url: "/whats-new",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./whatsNew/whats-new.html"], function() {
                  let template = require("./whatsNew/whats-new.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ]
          })
          .state("partnerWithUs", {
            url: "/partner-with-us/:subView",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(
                  ["./partnerWithUs/partner-with-us.html"],
                  function() {
                    let template = require("./partnerWithUs/partner-with-us.html");
                    deferred.resolve(template);
                  }
                );
                return deferred.promise;
              }
            ],
            resolve: {
              contactUs: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./partnerWithUs").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "PartnerWithUsController"
          })
          .state("workFromHotel", {
						url: "/workFromHotel",
						templateProvider: [
							"$q",
							function ($q) {
								let deferred = $q.defer();
								require.ensure(
									["./workFromHotel/workFromHotel.html"],
									function () {
										let template = require("./workFromHotel/workFromHotel.html");
										deferred.resolve(template);
									}
								);
								return deferred.promise;
							},
						],
						resolve: {
							workFromHotel: [
								"$q",
								"$ocLazyLoad",
								function ($q, $ocLazyLoad) {
									let deferred = $q.defer();
									require.ensure([], function () {
										let module = require("./workFromHotel").default(myApp);
										$ocLazyLoad.load({
											name: "app",
										});
										deferred.resolve(module);
									});

									return deferred.promise;
								},
							],
						},
						controller: "WorkFromHotelController",
					})
          .state("makePayment", {
            url: "/makePaymentForBooking/:bookingId",
            templateProvider: [
              "$q",
              function($q) {
                let deferred = $q.defer();
                require.ensure(["./makePayment/booking.html"], function() {
                  let template = require("./makePayment/booking.html");
                  deferred.resolve(template);
                });
                return deferred.promise;
              }
            ],
            resolve: {
              makePayment: [
                "$q",
                "$ocLazyLoad",
                function($q, $ocLazyLoad) {
                  let deferred = $q.defer();
                  require.ensure([], function() {
                    let module = require("./makePayment").default(myApp);
                    $ocLazyLoad.load({
                      name: "app"
                    });
                    deferred.resolve(module);
                  });

                  return deferred.promise;
                }
              ]
            },
            controller: "MakePaymentController"
          }).state("league", {
              url: "/bbsLeague",
              controller: "LeagueController",
              templateProvider: [
                  "$q",
                  function ($q) {
                      let deferred = $q.defer();
                      require.ensure(["./league/league.html"], function () {
                          let template = require("./league/league.html");
                          deferred.resolve(template);
                      });
                      return deferred.promise;
                  }
              ],
              resolve: {
                  league: [
                      "$q",
                      "$ocLazyLoad",
                      function ($q, $ocLazyLoad) {
                          let deferred = $q.defer();
                          require.ensure([], function () {
                              let module = require("./league").default(myApp);
                              $ocLazyLoad.load({
                                  name: "app"
                              });
                              deferred.resolve(module);
                          });

                          return deferred.promise;
                      }
                  ]
              },
              
          });

        $urlRouterProvider.otherwise("/");
        $locationProvider.html5Mode(true);
      }
    ]);

//Routes
